define('app/dashboard/DashboardListView',['require','glu/layout','./DashboardListItemView','glu/util','app/app','glu/dialog','hbs!./DashboardListView.hbs'],function(require) {

	'use strict';

	var Layout = require('glu/layout'),
		DashboardListItemView = require('./DashboardListItemView'),
		_ = require('glu/util'),
		App = require('app/app'),
		Dialog = require('glu/dialog'),
		tmpl = require('hbs!./DashboardListView.hbs');


	var selectedDashboard = null;

	return Layout.extend({
		template: tmpl,

		regions: {},

		initialize: function() {
			this.listenTo(this.collection, 'change:isSelected', function(dashboard, isSelected) {
				if (isSelected) {
					this.onDashboardSelected(dashboard);
				}
			});

			this.listenTo(this.collection, 'change:deleted', function(dashboard) {
				this.onDashboardRemoved(dashboard);
			});

			this.selectDashboardById(App.user.getLastSelectedDashboardId());
		},
		selectedDashboard: function() {
			return selectedDashboard;
		},

		onRender: function() {
			this.categorizeDashboards();
		},

		categorizeDashboards: function() {
			var self = this,
				curDash,
				containerSelector;

			for (var i = 0; i < this.collection.models.length; i++) {
				curDash = self.collection.models[i];
				if (curDash.get('dashboardType') === 'FIXED' || curDash.get('dashboardType') === 'STANDARD') {
					containerSelector = '#dash-standard';
				} else if (curDash.get('dashboardType') === 'SHARED' || (curDash.get('owner') !== 'system' && curDash.get('owner') !== App.user.getUsername()) && !App.user.isInternalUser()) {
					containerSelector = '#dash-shared';
				} else {
					containerSelector = '#dash-custom';
				}
				this.$el.find(containerSelector + ' ul').append('<li class="dashboard' + curDash.get('id') + '"></li>');
				self.addRegion('dash' + curDash.get('id'), containerSelector + ' ul .dashboard' + curDash.get('id'));

				self['dash' + curDash.get('id')].show(new DashboardListItemView({
					model: curDash
				}));
			}
		},

		selectDashboardById: function(id, isAfterSync) {
			if (this.collection.length === 0) {
				if (isAfterSync) {
					throw new Error('No dashboards found.');
				}
				this.collection.once('sync', _.bind(this.selectDashboardById, this, id, true));
				return;
			}

			var dashboard = this.collection.get(id);

			if (!dashboard) {
				dashboard = this.collection.models[0];
			}

			if (dashboard) {
				dashboard.set('isSelected', false); // REVIEW: Setting it to false first ensures a change event. How can we avoid this step?
				dashboard.set('isSelected', true);
			}
		},

		onDashboardSelected: function(dashboard) {
			selectedDashboard = dashboard;
			this.setLastSelectedDashboardId(dashboard.id);
			this.unselectOtherDashboards(dashboard);

			var self = this;
			if (dashboard) {
				if (dashboard.get('dashboardType') === 'CUSTOM' && dashboard.get('owner') !== App.user.getUsername() && !App.user.isInternalUser()) {
					dashboard.fetch().then(function() {
						if (dashboard.get('isPrivate') || dashboard.get('isDeleted')) {
							Dialog.error('Sorry, we could not find this dashboard. It is possible that dashboard was deleted, or is inaccessible due to other reasons.', 'Dashboard not found');
							self.onDashboardRemoved(dashboard);
						}
					});
				}
				dashboard.set('isSelected', true);
				dashboard.trigger('change');
			}

			this.trigger('change:selection');
			this.trigger('nav:dashboard', dashboard);
		},

		onDashboardRemoved: function(dashboard) {
			// Close view, remove element, remove model
			this['dash' + dashboard.get('id')].close();
			this.$el.find('.dashboard' + dashboard.get('id')).remove();
			dashboard.destroy();

			this.selectDashboardById(this.collection.models[0].get('id'));
		},

		onDashboardAdded: function(id) {
			// Dashboard should be blank, since it is new. No need to fetch or sync.
			this.render();
			this.selectDashboardById(id, true);
		},

		unselectAllDashboards: function() {
			selectedDashboard = null;
			this.setLastSelectedDashboardId(null);
			this.collection.each(function(dashboard) {
				dashboard.set('isSelected', false);
			});
			this.trigger('change:selection');
		},

		unselectOtherDashboards: function(thisDashboard) {
			this.collection.each(function(dashboard) {
				if (dashboard.id !== thisDashboard.id) {
					dashboard.set('isSelected', false);
				}
			});
		},

		getLastSelectedDashboardId: function() {
			App.user.getLastSelectedDashboardId();
		},

		setLastSelectedDashboardId: function(id) {
			App.user.setLastSelectedDashboardId(id);
		},

		selectFirstDashboard: function() {
			// select the first dashboard 
			if (this.collection.length > 0) {
				var dashboard = this.collection.models[0];
				this.onDashboardSelected(dashboard);
			} else {
				this.unselectAllDashboards();
			}
		},

		findSelectedDashboard: function(id) {
			return this.collection.filter(function(d) {
				return (d.id === id);
			});
		},

		filterUserDashboards: function(username) {
			var str = '(' + username + ')';
			this.collection.reset(this.collection.filter(function(dashboard) {
				if (dashboard.get('dashboardType') === 'FIXED' ||
					dashboard.get('dashboardType') === 'SHARED') {
					return true;
				} else if (dashboard.get('name').indexOf(str) > -1) {
					var name = dashboard.get('name');
					var index = name.indexOf('(');
					if (index > 0) {
						dashboard.set('name', name.slice(0, index - 1));
					}
					return true;
				}
			}, str));
		}
	});
});

